import { createSlice } from "@reduxjs/toolkit";
import { login } from "./authBaseApi";

const authSlice = createSlice({
    name: "auth",
    initialState: {
      token: localStorage.getItem("token") || null,
      isAuthenticated: false,
      loading: false,
      error: null,
    },
    reducers: {
      logout: (state) => {
        state.token = null;
        state.isAuthenticated = false;
        localStorage.removeItem("token");
      },
    },
    extraReducers: (builder) => {
      builder
        .addCase(login.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(login.fulfilled, (state, action) => {
          state.token = action.payload.token;
          state.isAuthenticated = true;
          state.loading = false;
          localStorage.setItem("token", action.payload.token);
        })
        .addCase(login.rejected, (state, action) => {
          state.error = action.error.message;
          state.loading = false;
        });
    },
  });
  
  export const { logout } = authSlice.actions;
  export default authSlice.reducer;